import { render, staticRenderFns } from "./NotificationContentPurchase.vue?vue&type=template&id=0b4d0348&scoped=true&"
import script from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
export * from "./NotificationContentPurchase.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationContentPurchase.vue?vue&type=style&index=0&id=0b4d0348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d0348",
  null
  
)

export default component.exports